import { faCircleXmark } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { AUTH_FORM_GENERIC_ERROR_MESSAGE } from "@shared/constants";

interface Props {
  message?: string;
}

export default function ServerError({
  message = AUTH_FORM_GENERIC_ERROR_MESSAGE,
}: Props) {
  return (
    <div
      className="bg-red-50 border border-red-600 flex gap-2 items-center opacity-80 px-2 py-4 rounded-lg text-neutral-900"
      data-spec="auth-form-server-error"
      role="alert"
    >
      <FontAwesomeIcon className="text-red-600" icon={faCircleXmark} />
      <span className="font-semibold">{message}</span>
    </div>
  );
}
